// extracted by mini-css-extract-plugin
export var active = "_1r-9";
export var backButton = "_1r-8";
export var clone = "_1r-e";
export var collapseBar = "_1r-k";
export var collapseMode = "_1r-m";
export var collapsed = "_1r-o";
export var dimmed = "_1r-i";
export var dragHandle = "_1r-c";
export var dropdownIcon = "_1r-g";
export var expanding = "_1r-n";
export var hidden = "_1r-x";
export var iconContainer = "_1r-q";
export var iconSwapper = "_1r-w";
export var navItem = "_1r-6";
export var navItemIcon = "_1r-f";
export var navProfile = "_1r-7";
export var notificationCountBadge = "_1r-j";
export var notificationDot = "_1r-r";
export var optionsContainer = "_1r-h";
export var primaryNav = "_1r-0";
export var primaryNavDivider = "_1r-v";
export var primaryNavResizeHandle = "_1r-2";
export var primaryNavResizing = "_1r-1";
export var primaryNavTabSection = "_1r-u";
export var primaryTab = "_1r-p";
export var primaryTabIconBox = "_1r-s";
export var secondaryNav = "_1r-3";
export var selected = "_1r-t";
export var settingsNav = "_1r-4";
export var settingsNavItems = "_1r-5";
export var show = "_1r-d";
export var sideNav = "_1r-l";
export var teamItem = "_1r-a";
export var userProfileItem = "_1r-b";